import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

interface ThumbnailProps {
  size?: number;
  image_url: string;
  alt?: string;
}

export const Thumbnail = ({ size = 56, image_url, alt }: ThumbnailProps) => {
  return (
    <ThumbnailCover size={size}>
      <Image src={image_url} alt={alt} />
    </ThumbnailCover>
  );
};

const ThumbnailCover = styled.div<{ size: number }>`
  border-radius: 50%;
  background-color: ${vars.color.staticWhite};
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  overflow: hidden;
  box-sizing: content-box;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 1px solid ${vars.color.dividerThinStrong};
    border-radius: 50%;
    pointer-events: none;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
`;
